/*
* Created on May 28, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import {createContext, useContext, useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";


const GlobalConfigContext = createContext(null);
export const useGlobalConfigContext = () => useContext(GlobalConfigContext);

export const GlobalConfigProvider = ({children}) => {
    const {i18n} = useTranslation();

    const useCurrentLang = () => {
        let userLang = window.localStorage.getItem('userLang');
        if (userLang) return userLang;

        let browserLang = window.navigator.userLanguage || window.navigator.language || 'en';
        if (browserLang.startsWith('en')) {
            browserLang = 'en';
        }
        if (browserLang.startsWith('zh')) {
            const country = browserLang.toLowerCase().split(/[_-]/)[1]
            browserLang = country === 'tw' ? 'zh_TW': 'zh';
        }
        const localUser = JSON.parse(window.localStorage.getItem('currentUser'));

        if (localUser) {
            userLang = localUser.language;
        }
        else {
            userLang = browserLang;
        }
        window.localStorage.setItem('userLang', userLang);
        i18n.changeLanguage(userLang);

        return userLang
    }

    return (
        <GlobalConfigContext.Provider value={{useCurrentLang}}>
            {children}
        </GlobalConfigContext.Provider>
    );
};
